import { render, staticRenderFns } from "./congtaiMonitor.vue?vue&type=template&id=a3dffd60&scoped=true&"
import script from "./congtaiMonitor.vue?vue&type=script&lang=js&"
export * from "./congtaiMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3dffd60",
  null
  
)

export default component.exports